<template>
  <div class="layout-left-menu-container">
    <TabView style="padding: 0px">
      <TabPanel :header="translate('tab.header.search')">
        <p></p> <!-- Don't Remove -->
        <SearchProfiles></SearchProfiles>
      </TabPanel>
      <TabPanel :header="translate('tab.header.Profile')">
        <p></p> <!-- Don't Remove -->
        <SavedProfiles></SavedProfiles>
      </TabPanel>
      <TabPanel :header="translate('tab.header.export')">
        <p></p> <!-- Don't Remove -->
        <ExportProfiles></ExportProfiles>
      </TabPanel>
    </TabView>
  </div>
</template>

<script>

import SearchProfiles from "../components/SearchProfiles";
import SavedProfiles from "../components/SavedProfiles";
import ExportProfiles from "../components/ExportProfiles";
import TranslateService from "../services/translate.service";

export default {

  name: "AppLeftMenu",
  components: {SearchProfiles, SavedProfiles, ExportProfiles},
  data() {
    return {}
  },
  computed: {},
  methods: {
    translate(message) {
      return TranslateService.translateMessage(message);
    },

  },
  mounted() {

  }
}
</script>

<style scoped>

</style>